import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import FeedbackCard from "./FeedbackCard";

const feedbacks = [
  {
    id: 1,
    name: "Francisco José Souza Faria",
    message: "O melhor atendimento da cidade, variedade e comprometimento com a satisfação do cliente.",
    rating: 5,
  },
  {
    id: 2,
    name: "Mauricio Silva",
    message: "Ótima experiência, atendimento excelente. Agilidade e profissionalismo.",
    rating: 5,
  },
  {
    id: 3,
    name: "Isa Freitas",
    message: "Super recomendo! Excelente atendimento do início ao fim da negociação! O vendedor Augusto está de parabéns! Muito obrigada!",
    rating: 5,
  },
  {
    id: 4,
    name: "Mariana Maia",
    message: "Atendimento excelente muito atencioso a todo momento, desde o início da compra até a entrega da chave!",
    rating: 5,
  },

];

const FeedbackCarousel = () => {
  return (
    <section className="py-16">
      <div className="mx-auto max-w-7xl px-4">
        <h2 className="mb-10 text-center text-3xl font-bold text-white">
          O que nossos <span className="text-orange-500">clientes</span> dizem
        </h2>

        <Swiper
          modules={[Navigation]}
          navigation
          spaceBetween={24}
          slidesPerView={1}
          breakpoints={{
            640: { slidesPerView: 2 },
            1024: { slidesPerView: 4 },
          }}
          className="pb-10"
        >
          {feedbacks.map((feedback) => (
            <SwiperSlide key={feedback.id} className="h-auto">
              <FeedbackCard feedback={feedback} />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default FeedbackCarousel;
